export default {
  setTerm({ commit }, term) {
    commit('setTerm', term)
  },
  setFilter({ commit }, filter) {
    commit('setFilter', filter)
  },
  clearSearch({ commit }) {
    commit('clearSearch')
  },
}
